import { Panel } from '@app/components/base/content-structure/Panel';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectionListItem } from './ConnectionListItem';
import { connectionsManageMessages as messages } from './connections-manage-messages';
import { PlatformConnectFactory } from './platforms/PlatformConnectFactory';

type Props = {
  platform: SocialPlatform;
  connections: SocialExportGetConnectionStateDto[];
  selectedConnectionId: string | null;
  onSelect: (connectionId: string) => void;
};

/**
 * Left navigation panel listing all connections for the current platform.
 */
export function ConnectionsListPanel({
  platform,
  connections,
  selectedConnectionId,
  onSelect,
}: Props) {
  return (
    <Panel
      title={<FormattedMessage {...messages.connectedAccounts} />}
      actions={<PlatformConnectFactory platform={platform} />}
      sx={{ height: '100%' }}
    >
      <Stack spacing={1.5}>
        {connections.map((connection) => (
          <ConnectionListItem
            key={connection.id}
            connection={connection}
            selected={connection.id === selectedConnectionId}
            onSelect={onSelect}
          />
        ))}
      </Stack>
    </Panel>
  );
}
